import { ToggleButtonGroup, ToggleButton, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { DEFAULT_FILTER_VALUE } from "constant"

export const LevelFilterBar = ({ levels, onChange, value, sx }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides =
    theme.components[`LevelFilterBar`]?.styleOverrides || {}
  const { root } = styleOverrides

  return (
    <ToggleButtonGroup
      onChange={onChange}
      value={value}
      exclusive
      sx={deepmerge(root, sx)}
    >
      <ToggleButton value={DEFAULT_FILTER_VALUE} color="standard">
        {t("All Floors")}
      </ToggleButton>
      {levels.map((level) => (
        <ToggleButton
          key={`level-filter-${level.properties.ordinal}`}
          value={level.properties.ordinal}
        >
          {level.properties.name.en}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
